export function NotFound() {
  return (
    <>
      <h1>404 - Page Not Found</h1>
    </>
  )
}
